import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IGeoMappingItem } from '../models/geoMappingItem'

export const getGeoMappingCrud = () =>
  CrudStore.get(CrudStoreItemPartner360.GeoMapping) as Crud<IGeoMappingItem>
